<script>
import {mapState} from "vuex";
const backofficeVersion = process.env.VUE_APP_BACKOFFICE_VERSION;
const backofficeDomain = process.env.VUE_APP_BACKOFFICE_DOMAIN;

export default {
  name: "sidebar",
  data: () => ({
    expandSingle: false,
    showRealRoute: {
      85: true,
      84: true,
      83: true,
      229: true,
    }
  }),
  computed: {
    itemSorted() {
      return this.items
          .sort((item) => item.order);
    },
    ...mapState("menu", ["items", 'showNavMenu', 'rolesOfUser']),
    ...mapState("auth", ["user"]),
  },
  methods: {
    toSlash(text) {
      return text.replace(/ /g, '-').toLowerCase();
    },
    getRoute(child) {
      if (this.isExternalRoute(child)) {
        return `${backofficeDomain}${child.route.path}`;
      }

      if (child.force_url && child.force_url === true) {
        return child.route.path;
      }

      return `/bo/${child.id}/${this.toSlash(child.text)}`
    },
    isExternalRoute(child) {
      return !child.version || child.version !== backofficeVersion;
    },
    canView(menuItem) {
      if (menuItem.route.permissions) {
        const result = menuItem.route.permissions.filter((role) => {
          return this.rolesOfUser.includes(role);
        })
        return result.length > 0;
      }
      return false;
    }
  }
}
</script>

<template>
  <div class="min-h-screen bg-dark md:w-2/12 w-1/12 transition" v-if="showNavMenu">
    <div class="flex justify-between flex-col h-full">
      <div class="md:py-5 md:px-10 text-center px-2 py-2">
        <img
            class="w-8/12"
            v-lazy="'https://cdn.redgirasol.com/green/LOGOS/redgirasol.png'"
            alt="Logotipo"/>
      </div>
      <div class="flex-1 px-2 text-white">
        <div>
          <ul class="flex flex-col space-y-2">
            <li v-for="item in itemSorted">
              <strong class="md:block hidden uppercase text-xs font-medium text-gray-400">
                {{ item.text }}
              </strong>

              <ul class="mt-2 space-y-1" v-if="!user.change_password">
                <li v-for="child in item.children" v-if="canView(child)">
                  <template v-if="!isExternalRoute(child)">
                    <router-link
                        :to="getRoute(child)"
                        class="flex bg-dark items-start rounded-lg text-white no-underline px-4 py-2 text-sm font-medium"
                    >
                      <vs-icon :icon="child.icon" class="mr-2"></vs-icon>
                      <span class="md:block hidden">
                        {{ child.text }}
                      </span>
                    </router-link>
                  </template>
                  <template v-else>
                    <a
                        :href="getRoute(child)"
                        class="flex bg-dark items-start rounded-lg text-white no-underline px-4 py-2 text-sm font-medium"
                    >
                      <vs-icon :icon="child.icon" class="mr-2"></vs-icon>
                      <span class="md:block hidden">
                        {{ child.text }}
                      </span>
                    </a>
                  </template>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>